<template>
  <section class="c-map">
    <div class="o-flexembed c-map__map c-map__map--search">
      <div class="o-flexembed__item t-bg--gray-300">
        <GmapMap
          ref="unitsmap"
          :center="center"
          :zoom="7"
          :options="mapOptions"
          map-type-id="terrain"
          style="width: 100%; height: 100%"
          @bounds_changed="onBoundsChanged"
          @dragstart="onDragStart"
          @dragend="onDragEnd"
          @click="onClick"
        >
          <GmapInfoWindow
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="infoWinOpen = false"
          >
            <card-listing
              :item="infoContent[0]"
              v-if="
                infoContent.length === 1 && infoContent[0].entitytypeid === 1
              "
              listing-type="map"
            />
            <complex-listing
              :item="infoContent[0]"
              v-if="
                infoContent.length === 1 && infoContent[0].entitytypeid === 2
              "
              listing-type="map"
            />
            <card-slider :items="infoContent" v-if="infoContent.length > 1" />
          </GmapInfoWindow>
          <!-- <GmapCluster :grid-size="20" :minimum-cluster-size="2"> -->
          <GmapMarker
            :key="index"
            v-for="(m, index) in markers"
            :animation="m.animation"
            :position="m.position"
            :icon="m.icon"
            :clickable="true"
            @click="toggleInfoWindow(m, index)"
          />

          <!-- </GmapCluster> -->
        </GmapMap>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import CardListing from '@/components/Listing/CardListing.vue'
import ComplexListing from '@/components/Listing/ComplexListing.vue'
import CardSlider from '@/components/Listing/CardSlider.vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: global.vesteda.mapsKey,
    libraries: 'geometry',
  },
})

export default {
  name: 'MapListing',
  components: {
    'card-listing': CardListing,
    'complex-listing': ComplexListing,
    'card-slider': CardSlider,
  },
  props: {
    items: Array,
    locationSearch: Boolean,
    latitude: String,
    longitude: String,
    distance: Number,
    zoomChanged: Function,
  },
  data() {
    return {
      mapInitialized: false,
      boundsSet: false,
      isDragging: false,
      infoContent: {},
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      mapOptions: {
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
      },
    }
  },
  computed: {
    combinedItems() {
      const itemsWithCoords = this.items.filter(
        (item) => item.latitude != null && item.longitude != null
      )

      let combined = new Map()

      itemsWithCoords.forEach((item) => {
        const key = `${item.latitude}-${item.longitude}`

        if (!combined.has(key)) {
          combined.set(key, {
            items: [],
            latitude: item.latitude,
            longitude: item.longitude,
            isActive: false,
          })
        }

        if (!combined.get(key).isActive) {
          combined.get(key).isActive = item.isActive
        }

        combined.get(key).items.push(item)
      })

      return combined
    },
    markers() {
      var gmaps = VueGoogleMaps.gmapApi()

      var markers = []

      this.combinedItems.forEach((item) => {
        const marker = {
          position: {
            lat: item.latitude,
            lng: item.longitude,
          },
          animation: item.isActive ? gmaps.maps.Animation.BOUNCE : null,
          icon: `${global.vesteda.assetsFolder}maps/markers/marker.png`,
          data: item.items,
        }

        markers.push(marker)
      })

      return markers
    },
    center() {
      if (this.mapInitialized) {
        return this.bounds.getCenter()
      }

      return { lat: 51, lng: 4 }
    },
    bounds() {
      let gmaps = VueGoogleMaps.gmapApi()

      const markerBounds = new gmaps.maps.LatLngBounds()
      if (this.markers.length > 0) {
        for (let m of this.markers) {
          markerBounds.extend(m.position)
        }
      }

      return markerBounds
    },
  },
  methods: {
    centerMap() {
      this.$refs.unitsmap.fitBounds(this.bounds)
      this.$refs.unitsmap.panToBounds(this.bounds)
    },
    onBoundsChanged(newBounds) {
      if (newBounds && !this.isDragging) {
        if (this.boundsSet) {
          let gmaps = VueGoogleMaps.gmapApi()
          let lat = newBounds.getCenter().lat()
          let lng = newBounds.getCenter().lng()

          let distanceInMeters =
            gmaps.maps.geometry.spherical.computeDistanceBetween(
              newBounds.getCenter(),
              newBounds.getNorthEast()
            )

          let distanceInKm = Math.round(distanceInMeters / 1000)

          if (
            this.zoomChanged &&
            distanceInKm > 0 &&
            this.infoWinOpen === false
          ) {
            this.zoomChanged(lat, lng, distanceInKm)
            this.boundsSet = false
          }
        } else {
          this.boundsSet = true
        }
      }
    },
    onClick() {
      this.infoWinOpen = false
      this.currentMidx = null
    },
    onDragStart() {
      this.isDragging = true
    },
    onDragEnd() {
      this.isDragging = false
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = marker.data

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    },
  },
  mounted() {
    this.$gmapApiPromiseLazy().then(() => {
      this.centerMap()
      this.mapInitialized = true
    })
  },
}
</script>

<style>
.vue-map-container {
  width: 100%;
  height: 100%;
}

.vue-map {
  width: 100%;
  height: 100%;
  position: unset !important;
}

.vue-map div.gm-style-iw > button {
  display: none !important;
}

.vue-map div.gm-style-iw-d {
  overflow: hidden !important;
}
</style>
